<!-- Card -->
<section class="card mb-2">
  <!-- Header -->
  <div class="card-header d-flex justify-content-between">
    <h3 class="card-title">
      <i role="img" class="fa fa-cube" aria-hidden="true"></i>
      {{ 'general.items' | translate }}
    </h3>
    <div class="d-flex">
      <button
        class="btn btn-white btn-sm"
        (click)="downloadCSV('pdf')"
        type="button"
      >
        {{ 'general.extract' | translate }}

        <span
          *ngIf="isLoading$ | async"
          class="spinner-border spinner-border-sm ms-2"
          role="status"
          attr.aria-label="{{ 'general.loading' | translate }}"
        >
        </span>
      </button>

      <button
        *ngIf="
          !readonly && (!(isSalePaid$ | async) || (multidayEnabled$ | async))
        "
        class="btn btn-primary btn-sm"
        (click)="onClickAddSaleItem()"
        [canSee]="[accessRights.Sales_write]"
        [disabled]="(sale$ | async)?.statusCode == saleStatusCodes.CANCELLED"
        type="button"
        data-test-id="add-sale-item-button"
      >
        {{ 'saleModule.addSaleItems' | translate }}
      </button>
    </div>
  </div>
  <!-- End Header -->

  <!-- Body -->
  <div class="">
    <div
      *ngIf="isLoading$ | async"
      class="spinner-border"
      role="status"
      attr.aria-label="{{ 'general.loading' | translate }}"
    >
    </div>
    <dms-table
      [tableData]="saleItems$ | async"
      [resetTableData$]="resetTableData$.asObservable()"
      [tableType]="'saleItems'"
      [readonly]="readonly"
      [resetAllChecked$]="resetAllChecked$"
      (onClickRow)="onClickRow($event)"
      (onClickDelete)="onClickDelete($event, true)"
      (onEditBulkAction)="onEditBulkAction($event)"
      [saleItemsAreAdjustable]="true"
      [bulkActions]="
        (sale$ | async)?.total < 0
          ? []
          : [
              BulkAction.SET_IS_USED,
              BulkAction.SET_IS_NOT_USED,
              BulkAction.CREATE_SEPARATE_SALE
            ]
      "
      [saleItemViewBulkActions]="
        (sale$ | async)?.total < 0
          ? []
          : [
              BulkAction.SET_IS_USED,
              BulkAction.SET_IS_NOT_USED,
              BulkAction.CREATE_SEPARATE_SALE
            ]
      "
      (onBulkAction)="onBulkAction($event)"
      [showIsUsedColumnSaleItemView]="true"
    >
    </dms-table>
  </div>
  <!-- End Body -->
</section>
<!-- End Card -->
